export default __webpack_public_path__ + "static/media/Acolyte's Legguards of the Sacred Mountain.85c49431.jpg";